module.exports = __webpack_public_path__ + "img/cnu_gallery0.d724d501.jpg";